// helpers/rutaClientes.js
import axios from "axios";

// SIN slash final (y por las dudas lo quito)
const RAW_BASE_URL = import.meta.env?.VITE_API_URL || "https://backsanpancracio.us-3.evennode.com";
const BASE_URL = RAW_BASE_URL.replace(/\/+$/, ""); // ← saca / al final

const API = axios.create({ baseURL: BASE_URL });

// arma paths sin doble slash (y sin slash al inicio)
const p = (s) => String(s || "").replace(/^\/+/, ""); // ← saca / al principio

const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};

// DEBUG: para ver la URL final en consola cuando haga el POST
const debugUrl = (url) => console.log("👉 URL:", API.getUri({ url }));

// ---- CLIENTES ----
export const getClientes = async () => {
  debugUrl(p("clientes"));
  const { data } = await API.get(p("clientes"), auth());
  return Array.isArray(data?.clientes) ? data.clientes : (Array.isArray(data) ? data : []);
};

export const getClienteById = async (id) => {
  debugUrl(p(`clientes/${id}`));
  const { data } = await API.get(p(`clientes/${id}`), auth());
  return data;
};

export const postCliente = async (payload) => {
  debugUrl(p("clientes"));
  const { data } = await API.post(p("clientes"), payload, auth());
  return data;
};

export const putCliente = async (id, payload) => {
  debugUrl(p(`clientes/${id}`));
  const { data } = await API.put(p(`clientes/${id}`), payload, auth());
  return data;
};

export const deleteCliente = async (id) => {
  debugUrl(p(`clientes/${id}`));
  const { data } = await API.delete(p(`clientes/${id}`), auth());
  return data;
};
